import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-twomorewhite",
  "use": "icon-twomorewhite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-twomorewhite\">\n  <path d=\"M2.95966 11.5405L3.87889 12.4597L8.33851 8.0001L3.87889 3.54048L2.95966 4.45972L6.50004 8.0001L2.95966 11.5405ZM7.95959 11.5405L8.87883 12.4597L13.3384 8.0001L8.87883 3.54048L7.95959 4.45972L11.5 8.0001L7.95959 11.5405Z\" fill=\"#ffffff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol